// extracted by mini-css-extract-plugin
export default {"nav":"nav--il6eK","button":"button--il6eK","back":"back--il6eK","next":"next--il6eK","hidden":"hidden--il6eK","slider":"slider--il6eK"};